// extracted by mini-css-extract-plugin
export default {"congrats":"SpecialEffect_congrats__vvlDV"};